
const SurveyEditor = () => import("../views/survey-editor.vue");
const SurveyView = () => import("../views/survey-view.vue");
const SurveyDash = () => import("../views/survey-dash.vue");
const AdminCoursewareEditor = () => import("../views/admin-courseware-editor.vue");
const PaperRefers = () => import("../views/paper-refers.vue");
const MediaRefers = () => import("../views/media-refers.vue");
const CoursewareRefers = () => import("../views/courseware-refers.vue");
const MediaRepo = () => import("../views/media-repo.vue");
const CoursewareRepo = () => import("../views/courseware-repo.vue");
const QuestionRepo = () => import("../views/question-repo.vue");
const PaperRepo = () => import("../views/paper-repo.vue");
const ArticleRepo = () => import("../views/article-repo.vue");
const ClazzruleRepo = () => import("../views/clazzrule-repo.vue");
const PaperImportParse = () => import("../views/paper-import-parse.vue");
const RatingFeedback = () => import("../components/rating-feedback.vue");
const LangSettings = () => import("../views/lang-settings.vue");
const AdminArticle = () => import("../views/admin-article.vue");

import { CrudRouter, AutoRouter, TreeCrudRouter, BigfileUploader, SimpleUploader, DataList, Tree } from "javaee-fre";

import { catalogTree, orgTree } from "./comm-func.js";

function mediaCrudMeta(readOnly) {
    return {
        tree: { disableActiveFirst: true, ...catalogTree() },
        acceptEmptyActive: true,
        crud(i) {
            let self = this, a = self.$store.state.account;
            let cfgs = {
                genParams(i) {
                    if (i) {
                        return { _cata: i.domainId ? i.id : 0, _domain: i.domainId || i.id };
                    } else {
                        return {};
                    }
                },
                desc: (i != null && !readOnly) ? null : '<p class="sys-info">选择左边<b>资源分类目录</b>开始<b>新建</b>并<b>上传</b>视频</p>',
                createable: i != null && !readOnly,
                editable: !readOnly,
                deleteable: !readOnly,
                listItemActions() {
                    let acts = [{
                        label: '收藏', icon: 'favorite_border', func(cfg) {
                            this.$favorite(1, cfg.item.id);
                        }
                    }, {
                        label: '播放', icon: 'play_circle_outline', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/my/media/cc/url/${cfg.item.id}`).then(r => {
                                if (r.data && r.data.status == 'ok' && r.data.message) {
                                    self.$dialog.component(cfg.item.name, 'cc-video-viewer', { movieUrl: r.data.message });
                                }
                            });
                        }
                    }, {
                        label: '引用课件', order: -1, icon: 'call_split', func(cfg) {
                            this.$dialog.component(`引用该视频的课件 - ${cfg.item.name}`, MediaRefers, { mediaId: cfg.item.id });
                        }
                    }];

                    if (!readOnly) {
                        acts = acts.concat([{
                            label: '上传视频', icon: 'cloud_upload', func(cfg) {
                                let self = this;
                                self.$dialog.component(`上传视频 - ${cfg.item.name}`, BigfileUploader, {
                                    persist: true,
                                    contentType: ["video/mp4", "video/quicktime", "video/avi"], width: 400,
                                    url: `/home/admin/c/media/chunk/upload/${cfg.item.id}`,
                                    maxSize: 1024 * 1024 * 800,
                                    onUploadSuccess() {
                                        self.$dialog.close();
                                        self.refresh();
                                        self.$status('上传成功！请耐心等待视频转码。', 'success');
                                    }
                                });
                            }
                        }, {
                            label: '禁用', icon: 'visibility_off', func(cfg) {
                                let self = this;
                                let status = self.$dictVal(cfg.item.status);
                                self.$axios.get(`/home/admin/c/media/status/${cfg.item.id}/${status != 1 ? 1 : 0}`).then(r => {
                                    if (r.data) {
                                        if (r.data.status == "ok") {
                                            self.$status('操作成功', 'success');
                                            self.refresh();
                                        } else {
                                            self.$status(r.data.message || "操作失败！", 'error');
                                        }
                                    }
                                });
                            }
                        }]);
                    }

                    // 系统级别的管理员才给操作
                    if (this.$store.state.account.originTenantId == 0) {
                        acts.push({
                            label: '复制CCID', icon: 'content_copy', func(cfg) {
                                let self = this;
                                let ccvid = self.$dictVal(cfg.item.ccvid);
                                if (ccvid) {
                                    let input = document.createElement('input');
                                    input.value = ccvid;
                                    input.style.position = 'fixed';
                                    input.style.opacity = 0;
                                    document.body.appendChild(input);
                                    input.select();
                                    document.execCommand('copy');
                                    self.$status("复制成功", 'success');
                                    input.remove();
                                } else {
                                    self.$status("没有CCID", 'error');
                                }
                            }
                        });
                    }
                    return acts;
                },
                listItemFilter(i, acts) {
                    let status = this.$dictVal(i.status);

                    if (i.duration) {
                        this.delAction(acts, "icon", "cloud_upload");
                    } else {
                        this.delAction(acts, "icon", "play_circle_outline");
                        if (status > 1 && status < 4) {
                            this.delAction(acts, "icon", "cloud_upload");
                        }
                    }

                    if (!readOnly && status != 1) {
                        let act = acts.find(a => a.icon == "visibility_off");
                        act.icon = "done";
                        act.label = "激活";
                    }
                    return acts;
                }
            };
            let acts = [];
            if (!readOnly) {
                cfgs.selectStyle = 'multi';
                acts = [{
                    label: '移动', whereSel: true, func() {
                        let self = this, sel = self.selected();
                        if (!sel) {
                            return;
                        }
                        let keys = Object.keys(sel);
                        if (keys.length <= 0) {
                            return;
                        }

                        self.$dialog.component('选择目标目录', Tree, { width: 300, ...catalogTree() }, [
                            {
                                label: '确认移动', func(sel) {
                                    if (!sel || !sel.actived) { return }
                                    sel = sel.actived;
                                    self.$axios.get(`/home/admin/c/media/catalog/move/${sel.domainId || sel.id}/${sel.domainId ? sel.id : 0}/${keys.join('_')}`).then(() => {
                                        self.refresh();
                                        self.$status('移动成功～', 'success');
                                    });
                                }
                            }
                        ]);
                    }
                }];
                if (a.tenantId == 0) {
                    acts.push({
                        label: '开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/media/update/pri/ids/false/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    }, {
                        label: '不开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/media/update/pri/ids/true/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    }, {
                        label: '分配短视频', whereSel: true, order: -10, func() {
                            let self = this, selected = self.selected();
                            self.$axios.get('/home/admin/sys/video/enabled/tenants').then(r => {
                                let msg = r.data.message;
                                if (!msg || msg.length <= 0) {
                                    self.$status('没有可分配的租户激活了短视频功能～', 'error');
                                    return;
                                }
                                function selCategoryId(tid) {
                                    self.$axios.get(`/home/admin/sys/video/tenant/categories/${tid}`).then(r => {
                                        let msg = r.data.message;
                                        if (!msg || msg.length <= 0) {
                                            self.$status('当前租户没有短视频分类～', 'error');
                                            return;
                                        }
                                        self.$dialog.select('选择需要分配的分类', { width: 400, items: msg, itemLabel: 'label', itemVal: 'id' }, [{
                                            label: '确认', color: 'primary', func(sel) {
                                                if (!sel) {
                                                    return;
                                                }
                                                self.$axios.get(`/home/admin/sys/video/distribute/to/${tid}/${sel}?mids=${Object.keys(selected).join('_')}`).then(r => {
                                                    if (r.data.status == 'ok') {
                                                        self.$status('分配成功～', 'success');
                                                        return;
                                                    }
                                                    self.$status(r.data.message || '分配失败', 'error');
                                                });
                                            }
                                        }]);
                                    });
                                }
                                self.$dialog.select('选择需要分配的租户', { width: 400, items: msg, itemLabel: 'name', itemVal: 'id' }, [{
                                    label: '下一步', color: 'primary', func(sel) {
                                        if (!sel) {
                                            return;
                                        }
                                        selCategoryId(sel);
                                    }
                                }]);
                            });
                        }
                    });
                    if (i) {
                        acts.push({
                            label: '按目录开放', confirm: '确认要把当前选中目录批量标记为开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/media/update/pri/batch/${i.domainId}/${i.id || 0}/false`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '按目录不开放', confirm: '确认要把当前选中目录批量标记为不开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/media/update/pri/batch/${i.domainId}/${i.id || 0}/true`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        });
                    }
                } else if (!a.orgId) {
                    if (a.enableShortVideo && (self.$isInRole('ROLE_TENANT_SHORT_V') || self.$isInRole('ROLE_TENANT_SUPER'))) {
                        acts.push({
                            label: '发布为短视频', whereSel: true, order: -10, func() {
                                let self = this, selected = self.selected();
                                self.$axios.get('/home/admin/my/tenant/video/category/list/0/100').then(r => {
                                    let msg = r.data.message;
                                    if (!msg || msg.length <= 0) {
                                        self.$status('请先建立短视频分类', 'error');
                                        return;
                                    }
                                    self.$dialog.select('请选择短视频分类', { width: 400, items: msg, itemLabel: 'label', itemVal: 'id' }, [{
                                        label: '确认', color: 'primary', func(sel) {
                                            if (!sel) {
                                                return;
                                            }
                                            self.$axios.get(`/home/admin/my/tenant/video/media/to/video/${sel}?mids=${Object.keys(selected).join('_')}`).then(r => {
                                                if (r.data.status == 'ok') {
                                                    self.$status('发布成功～', 'success');
                                                    return;
                                                }
                                                self.$status(r.data.message || '发布失败', 'error');
                                            });
                                        }
                                    }]);
                                });
                            }
                        });
                    }
                }



                cfgs.listActions = acts;
            }
            return cfgs;
        }
    };
}

function coursewareCrudMeta(readOnly) {
    return {
        tree: { disableActiveFirst: true, ...catalogTree() },
        acceptEmptyActive: true,
        crud(i) {
            let self = this, listItemActions = [{
                label: '收藏', icon: 'favorite_border', func(cfg) {
                    this.$favorite(2, cfg.item.id);
                }
            }, {
                label: '编辑大纲和视频', icon: 'format_list_numbered', func(cfg) {
                    this.$router.push(`/console/home/admin/c/${readOnly ? 'ro_' : ''}courseware/edit/${cfg.item.id}`, `编辑大纲和视频 - ${cfg.item.name}`);
                }
            }, {
                label: '预览', icon: 'visibility', func(cfg) {
                    let self = this;
                    self.$dialog.component(`预览 - ${cfg.item.name}`, "courseware-view", {
                        fullscreen: true,
                        targetId: cfg.item.id
                    });
                }
            }, {
                label: '评价反馈', order: -1, icon: 'star_border', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/c/courseware/rating/tags/${cfg.item.id}`).then(r => {
                        if (r.data.status == 'ok' && r.data.message) {
                            self.$dialog.component(`${cfg.item.name} - 评价反馈`, RatingFeedback, { width: 600, id: cfg.item.id, result: r.data.message });
                            return;
                        }
                        self.$status('没有评价反馈', 'success');
                    });
                }
            }];

            if (!readOnly) {
                listItemActions.push({
                    label: '引用培训方案', order: -2, icon: 'call_split', func(cfg) {
                        this.$dialog.component(`引用该课件的培训计划 - ${cfg.item.name}`, CoursewareRefers, { coursewareId: cfg.item.id });
                    }
                }, {
                    label: '导入大纲和视频', icon: 'cloud_upload', func(cfg) {
                        let self = this;
                        self.$dialog.component(`导入 - ${cfg.item.name}`, SimpleUploader, {
                            width: 600,
                            persist: true,
                            url: `/home/admin/c/courseware/import/${cfg.item.id}`,
                            onUploadComplete(r) {
                                if (r.data && r.data.status == 'ok') {
                                    self.$dialog.close();
                                    self.$status('导入成功！', 'success');
                                    self.refresh();
                                } else {
                                    let err = r.data ? r.data.message : '导入出现错误';
                                    if (typeof err == 'string') {
                                        self.$status(err, 'error');
                                    } else {
                                        //弹出一个对话框，列出导入的错误列表
                                        self.$dialog.component('导入错误信息', DataList, {
                                            width: 600,
                                            heads: [{ label: '行', name: 'row' }, { label: '列', name: 'col' }, { label: '说明', name: 'message' }],
                                            data: r.data.message
                                        });
                                    }
                                }
                            }
                        });
                    }
                });

                listItemActions.push({
                    label: '禁用', icon: 'visibility_off', func(cfg) {
                        let self = this, status = self.$dictVal(cfg.item.status);
                        self.$axios.get(`/home/admin/c/courseware/status/${cfg.item.id}/${status != 1 ? 1 : 0}`).then(r => {
                            if (r.data) {
                                if (r.data.status == "ok") {
                                    self.$status('操作成功', 'success');
                                    self.refresh();
                                } else {
                                    self.$status(r.data.message || "操作失败！", 'error');
                                }
                            }
                        });
                    }
                });

                if (self.$isInRole('ROLE_SUPER')) {
                    listItemActions.push({
                        label: '语言设置', order: -10, icon: 'language', func(cfg) {
                            let self = this;
                            self.$dialog.component(`语言设置 - ${cfg.item.name}`, LangSettings, {
                                width: 800,
                                fields: [
                                    { category: 1, type: 1, categoryId: cfg.item.id, targetId: 0, label: '名称' },
                                    { category: 1, type: 2, categoryId: cfg.item.id, targetId: 0, label: '描述', textarea: true }
                                ]
                            });
                        }
                    });
                }
            }
            if (self.$isInRole('ROLE_SUPER') && self.$store.state.account.tenantId == 0 && !readOnly) {
                listItemActions.push({
                    label: '复制',
                    order: -9,
                    icon: 'flip_to_front',
                    func(cfg) {
                        let tid = null;
                        function _selCatalog() {
                            if (!tid) { return; }
                            self.$dialog.component(`选择复制目标分类 - ${cfg.item.name}`, Tree, { width: 500, ...catalogTree(tid) }, [{
                                label: '确认复制', func(cataSel) {
                                    if (!cataSel || !cataSel.actived) {
                                        return;
                                    }
                                    cataSel = cataSel.actived;
                                    self.$axios.get(`/home/admin/c/courseware/copy/${cfg.item.id}/${tid}/${cataSel.domainId || cataSel.id}/${cataSel.domainId ? cataSel.id : 0}`).then(r => {
                                        if (r && r.data && r.data.status == 'ok') {
                                            self.$status('复制成功！', 'success');
                                        } else {
                                            self.$status(r && r.data && r.data.message ? r.data.message : '复制失败！', 'error');
                                        }
                                    });
                                }
                            }]);
                        }
                        self.$dialog.crud(`选择复制目标租户 - ${cfg.item.name}`, { url: '/home/admin/sys/tenant', selectStyle: 'single', createable: false, editable: false }, [{
                            label: '下一步', func(sel) {
                                if (!sel) {
                                    return;
                                }
                                let keys = Object.keys(sel);
                                if (keys.length <= 0) {
                                    return;
                                }
                                tid = keys[0];
                                setTimeout(_selCatalog, 50);
                            }
                        }]);
                    }
                });

                listItemActions.push({
                    label: '分配课堂课件', order: -8, icon: 'call_received', func(i) {
                        let self = this;
                        self.$dialog.crud(`选择租户 - ${i.item.name}`, { url: '/home/admin/sys/clzroom/tenant', selectStyle: 'single' }, [{
                            label: '确认分配', color: 'primary', func(tsel) {
                                if (!tsel) {
                                    return;
                                }
                                tsel = Object.keys(tsel);
                                if (tsel.length == 0) {
                                    return;
                                }
                                let tid = tsel[0];
                                self.$axios.get(`/home/admin/sys/clzroom/courseware/add/courseware/${i.item.id}`, { params: { _tid: tid } }).then(r => {
                                    if (r.data) {
                                        if (r.data.status == "ok") {
                                            self.$status('分配成功', 'success');
                                            self.refresh();
                                        } else {
                                            self.$status(r.data.message || "分配失败！", 'error');
                                        }
                                    }
                                });
                            }
                        }]);
                    }
                });
            }

            let cfgs = {
                genParams(i) {
                    return i ? { _cata: i.domainId ? i.id : 0, _domain: i.domainId || i.id } : {};
                },
                desc: (i != null && !readOnly) ? null : '<p class="sys-info">选择左边<b>资源分类目录</b>开始<b>新建课件</b></p>',
                createable: i != null && !readOnly,
                editable: !readOnly,
                deleteable: !readOnly,
                listItemActions: listItemActions,
                listItemFilter(i, acts) {
                    if (this.$dictVal(i.status) != 1 && !readOnly) {
                        let act = acts.find(a => a.icon == "visibility_off");
                        act.icon = "done";
                        act.label = "激活";
                    }

                    if (i.leafCount > 0 || this.$store.state.account.tenantId != 0 || readOnly) {
                        acts = acts.filter(a => a.icon != 'cloud_upload');
                        return acts;
                    }

                    if (!i.rating) {
                        this.delAction(acts, 'icon', 'star_border');
                    }
                    return acts;
                }
            }

            if (!readOnly) {
                cfgs.selectStyle = 'multi';
                let acts = [{
                    label: '移动', whereSel: true, func() {
                        let self = this, sel = self.selected();
                        if (!sel) {
                            return;
                        }
                        let keys = Object.keys(sel);
                        if (keys.length <= 0) {
                            return;
                        }

                        self.$dialog.component('选择目标目录', Tree, { width: 300, ...catalogTree() }, [
                            {
                                label: '确认移动', func(sel) {
                                    if (!sel || !sel.actived) { return }
                                    sel = sel.actived;
                                    self.$axios.get(`/home/admin/c/courseware/catalog/move/${sel.domainId || sel.id}/${sel.domainId ? sel.id : 0}/${keys.join('_')}`).then(() => {
                                        self.refresh();
                                        self.$status('移动成功～', 'success');
                                    });
                                }
                            }
                        ]);
                    }
                }];
                if (self.$store.state.account.tenantId == 0) {
                    acts.push({
                        label: '开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/courseware/update/pri/ids/false/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    }, {
                        label: '不开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/courseware/update/pri/ids/true/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    }, {
                        label: '分配课堂课件', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                sel = Object.keys(sel);
                            }
                            if (!sel || sel.length == 0) {
                                self.$status('请选择需要分配的课件', 'error');
                                return;
                            }
                            self.$dialog.crud('选择租户', { url: '/home/admin/sys/clzroom/tenant', selectStyle: 'single' }, [{
                                label: '确认分配', color: 'primary', func(tsel) {
                                    if (!tsel) {
                                        return;
                                    }
                                    tsel = Object.values(tsel);
                                    if (tsel.length == 0) {
                                        return;
                                    }
                                    let tid = tsel[0].id;
                                    self.$axios.get(`/home/admin/sys/clzroom/courseware/add/courseware/${sel.join('_')}`, { params: { _tid: tid } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('分配成功', 'success');
                                                self.refresh(false, true);
                                            } else {
                                                self.$status(r.data.message || "分配失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    });
                    if (i) {
                        acts.push({
                            label: '按目录开放', confirm: '确认要把当前选中目录批量标记为开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/courseware/update/pri/batch/${i.domainId}/${i.id || 0}/false`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '按目录不开放', confirm: '确认要把当前选中目录批量标记为不开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/courseware/update/pri/batch/${i.domainId}/${i.id || 0}/true`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        });
                    }
                }
                cfgs.listActions = acts;
            }
            return cfgs;
        }
    };
}
const surveyCrudMeta = {
    createable: false, editable: false, detailable: false,
    routerBackRefreshCrudList: true,
    listActions: [{ label: '新建', func() { this.$router.push('/console/home/admin/c/survey/edit/0'); } }],
    listItemActions: [{
        label: '修改', icon: 'edit', func(cfg) {
            this.$router.push(`/console/home/admin/c/survey/edit/${cfg.item.id}`);
        }
    }, {
        label: '查看', icon: 'details', func(cfg) { this.$router.push(`/console/home/admin/c/survey/view/${cfg.item.id}`); }
    }, {
        label: '结果统计', icon: 'insert_chart', func(cfg) {
            this.$router.push(`/console/home/admin/c/survey/dash/${cfg.item.id}`);
        }
    }, {
        label: '发布', icon: 'check', func(cfg) {
            let self = this, i = cfg.item;
            self.$axios.get(`/home/admin/c/survey/update/closed/${i.id}/${!i.closed}`).then(() => {
                self.refresh();
            });
        }
    }],
    listItemFilter(i, acts) {
        if (i.joinCount) {
            this.delAction(acts, 'icon', 'edit');
        }
        if (!i.closed) {
            let a = acts.find(r => { return r.icon == 'check' });
            a.label = '关闭';
            a.icon = 'close';
        }
        return acts;
    }
}, routers = [
    {
        path: 'home/admin/c/survey', component: CrudRouter, meta: surveyCrudMeta,
        children: [
            { path: 'edit/:_sid', component: SurveyEditor, meta: { name: '查看问卷' } },
            { path: 'view/:_sid', component: SurveyView, meta: { name: '查看问卷' } },
            { path: 'dash/:_sid', component: SurveyDash, meta: { name: '结果统计' } }
        ]
    },
    {
        path: 'home/admin/c/notice', component: CrudRouter, meta: {
            listItemActions: [{
                label: '发布', icon: 'done', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/c/notice/update/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) == 0 ? 1 : 0}`).then(r => {
                        if (r.data && r.data.status == 'ok') {
                            self.$status('操作成功！', 'success');
                            self.refresh();
                            return;
                        }
                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                    });
                }
            }, {
                label: '上传附件', icon: 'attachment', func(cfg) {
                    let self = this;
                    if (cfg.item.pdf) {
                        self.$axios.post(`/home/admin/c/notice/update/pdf/${cfg.item.id}`).then(() => {
                            self.refresh();
                            self.$status('删除附件成功～', 'success');
                        });
                    } else {
                        self.$dialog.component('上传附件', SimpleUploader, {
                            width: 600, persist: true,
                            contentType: 'application/pdf',
                            url: `/home/admin/c/notice/upload/pdf?__entity_id=${cfg.item.id}&_attachs=true`,
                            onUploadSuccess(r, fn) {
                                if (r.data && r.data.success) {
                                    self.$axios.post(`/home/admin/c/notice/update/pdf/${cfg.item.id}`, self.$qs.stringify({ uuid: r.data.newUuid, fn: fn })).then(sr => {
                                        if (sr.data && sr.data.status == 'ok') {
                                            self.$dialog.close();
                                            self.refresh();
                                            self.$status('上传附件成功～', 'success');
                                        }
                                    });
                                }

                            }
                        });
                    }
                }
            }, {
                label: '关联视频', icon: 'videocam', func(cfg) {
                    let self = this;
                    self.$dialog.crud('从收藏中选择视频', { url: '/home/my/favorite', params: { _type: 1 }, selectStyle: 'single' }, [{
                        label: '确认添加', color: 'primary', func(sel) {
                            if (!sel) {
                                return;
                            }
                            let keys = Object.keys(sel);
                            if (keys.length < 1) {
                                return;
                            }
                            sel = sel[keys[0]];
                            self.$axios.get(`/home/admin/c/notice/update/video/${cfg.item.id}/${sel.targetId}`).then(r => {
                                if (r.data && r.data.status == 'ok') {
                                    self.$status('添加成功～', 'success');
                                    self.refresh();
                                }
                            });
                        }
                    }]);
                }
            }, {
                label: '取消关联的视频', icon: 'videocam_off', confirm: '确认要取消已经关联的视频？', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/c/notice/update/video/${cfg.item.id}/0`).then(r => {
                        if (r.data && r.data.status == 'ok') {
                            self.$status('取消成功～', 'success');
                            self.refresh();
                        }
                    });
                }
            }, {
                label: '播放视频', icon: 'play_circle_outline', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/my/media/cc/url/${cfg.item.videoId}`).then(r => {
                        if (r.data && r.data.status == 'ok' && r.data.message) {
                            self.$dialog.component(cfg.item.name, 'cc-video-viewer', { movieUrl: r.data.message });
                        }
                    });
                }
            }],
            listItemFilter(i, acts) {
                let status = this.$dictVal(i.status);
                if (status == 1) {
                    let act = acts.find(a => a.icon == "done");
                    act.icon = "visibility_off";
                    act.label = "取消发布";
                }
                if (i.pdf) {
                    let attachment = acts.find(a => a.icon == "attachment");
                    attachment.label = '删除附件';
                    attachment.icon = 'link_off';
                    attachment.confirm = '确认要删除附件吗？';
                }
                if (i.videoId) {
                    this.delAction(acts, "icon", "videocam");
                } else {
                    this.delAction(acts, "icon", "videocam_off");
                    this.delAction(acts, "icon", "play_circle_outline");
                }
                return acts;
            }
        }
    },
    {
        path: 'home/admin/c/catalog', component: TreeCrudRouter, meta: {
            tree: catalogTree(),
            crud: {
                titleField: 'label',
                genParams(i) {
                    return { _pid: i.domainId ? i.id : 0, _domain: i.domainId || i.id };
                },
                listItemFilter(i, acts) {
                    if (i.catalogCount > 0) {
                        let idx = acts.findIndex(a => a.__flag == "delete");
                        acts.splice(idx, 1);
                    }
                    return acts;
                }
            }
        }
    },
    {
        path: 'home/admin/c/media', component: TreeCrudRouter, meta: mediaCrudMeta(false)
    },
    {
        path: 'home/admin/c/ro_media', component: TreeCrudRouter, meta: {
            url: 'home/admin/c/media', ...mediaCrudMeta(true)
        }
    },
    {
        path: 'home/admin/c/courseware', component: TreeCrudRouter, meta: coursewareCrudMeta(false),
        children: [
            { path: 'edit/:id', component: AdminCoursewareEditor, meta: { name: '目录管理' } }
        ]
    },
    {
        path: 'home/admin/c/ro_courseware', component: TreeCrudRouter, meta: {
            url: 'home/admin/c/courseware', ...coursewareCrudMeta(true)
        },
        children: [
            { path: 'edit/:id', component: AdminCoursewareEditor, meta: { name: '目录管理', readOnly: true } }
        ]
    },
    {
        path: 'home/admin/c/question', component: TreeCrudRouter, meta: {
            tree: { disableActiveFirst: true, ...catalogTree() },
            acceptEmptyActive: true,
            crud(i) {
                let self = this, lacts = [{
                    label: '导出', order: -2, func() {
                        let self = this;
                        if (!self.searching) {
                            window.open(`${self.$const.baseUrl}/home/admin/c/question/export.xlsx?_t=${Date.now()}`);
                            return;
                        }
                        self.$dialog.select('选择导出类型', {
                            width: 400, items: [{ l: '导出全部', v: 1 }, { l: '导出搜索结果', v: 2 }], itemLabel: 'l', itemVal: 'v'
                        }, [{
                            label: '导出', color: 'primary', func(v) {
                                if (v == 1) {
                                    window.open(`${self.$const.baseUrl}/home/admin/c/question/export.xlsx?_t=${Date.now()}`);
                                } else {
                                    window.open(`${self.$const.baseUrl}/home/admin/c/question/export.xlsx?_t=${Date.now()}&${self.$qs.stringify(self.searchData())}`);
                                }
                            }
                        }])
                    }
                }, {
                    label: '批量更新', order: -3, func() {
                        let self = this;
                        self.$dialog.component('选择文件（按照导出的excel格式）', SimpleUploader, {
                            width: 600,
                            persist: true,
                            url: `home/admin/c/question/batch/update`,
                            onUploadComplete(r) {
                                self.$dialog.close();
                                self.$status(r.data.message, 'success');
                            }
                        });
                    }
                }, {
                    label: '移动', whereSel: true, func() {
                        let self = this, sel = self.selected();
                        if (!sel) {
                            return;
                        }
                        let keys = Object.keys(sel);
                        if (keys.length <= 0) {
                            return;
                        }

                        self.$dialog.component('选择目标目录', Tree, { width: 300, ...catalogTree() }, [
                            {
                                label: '确认移动', func(sel) {
                                    if (!sel || !sel.actived) { return }
                                    sel = sel.actived;
                                    self.$axios.get(`/home/admin/c/question/catalog/move/${sel.domainId || sel.id}/${sel.domainId ? sel.id : 0}/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                        self.$status('移动成功～', 'success');
                                    });
                                }
                            }
                        ]);
                    }
                }];
                if (i) {
                    lacts.push(
                        {
                            label: '加判断', func() {
                                this.$parent.onEdit(null, { _type: 2 });
                            }
                        },
                        {
                            label: '加单选', func() {
                                this.$parent.onEdit(null, { _type: 1 });
                            }
                        },
                        {
                            label: '加多选', func() {
                                this.$parent.onEdit(null, { _type: 3 });
                            }
                        },
                        {
                            label: '加复合', func() {
                                this.$parent.onEdit(null, { _type: 4 });
                            }
                        }
                    );
                }
                if (self.$isInRole('ROLE_SUPER')) {
                    lacts.push({
                        label: '多语言导入', order: -1, func() {
                            self.$axios.get('/home/admin/sys/lang/label/langs').then(r => {
                                self.$dialog.select('选择语言', { width: 400, items: r.data.message, itemLabel: 'name', itemVal: 'id' }, [{
                                    label: '下一步', color: 'primary', func(lang) {
                                        setTimeout(() => {
                                            self.$dialog.component('选择文件导入', SimpleUploader, {
                                                width: 600,
                                                persist: true,
                                                url: `home/admin/c/question/langs/import/${lang}`,
                                                templateUrl: '/s/a/ques_lang_import.xlsx',
                                                onUploadComplete(r) {
                                                    let s = r.data.status, msg = r.data.message;
                                                    self.$dialog.close();
                                                    if (s == 'ok') {
                                                        self.$status(`成功导入${msg.parsed}道，总共${msg.total}道`, 'success');
                                                    } else {
                                                        self.$status(msg || '导入失败～', 'error');
                                                    }
                                                }
                                            });
                                        }, 50);
                                    }
                                }]);
                            });
                        }
                    });
                }
                let cfgs = {
                    createable: false, refreshable: false,
                    selectStyle: 'multi',
                    desc: i ? null : '<p class="sys-info">选择左边<b>资源分类目录</b>开始<b>添加题目</b></p>',
                    genParams(i) {
                        return i ? { _cata: i.domainId ? i.id : 0, _domain: i.domainId || i.id } : {};
                    },
                    listActions: lacts,
                    listItemActions: [{
                        label: '收藏', icon: 'favorite_border', func(cfg) {
                            this.$favorite(3, cfg.item.id);
                        }
                    },
                    {
                        label: '题目预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component('题目预览', "question-view", {
                                targetId: cfg.item.id,
                            });
                        }
                    }, {
                        label: '小题管理', icon: 'list', func(cfg) {
                            self.$router.push(`/console/home/admin/c/question/sub/${cfg.item.id}`);
                        }
                    }, {
                        label: '语言设置', icon: 'language', func(cfg) {
                            let self = this;
                            self.$axios.get('/home/admin/sys/lang/label/langs').then(r => {
                                self.$dialog.select('选择语言', { width: 400, items: r.data.message, itemLabel: 'name', itemVal: 'id' }, [{
                                    label: '下一步', color: 'primary', func(lang) {
                                        setTimeout(() => {
                                            self.$dialog.crud('语言设置', {
                                                width: 800,
                                                url: '/home/admin/c/question', initPanel: 'edit', editable: true, targetId: cfg.item.id, params: { _lang: lang },
                                                onSaveSuccess() {
                                                    self.$dialog.close();
                                                    self.$status('设置成功～', 'success');
                                                }
                                            });
                                        }, 50);
                                    }
                                }]);
                            });
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (this.$dictVal(i.type) != 4) {
                            this.delAction(acts, 'icon', 'list');
                        }
                        if (!this.$isInRole('ROLE_SUPER')) {
                            this.delAction(acts, 'icon', 'language');
                        }
                        return acts;
                    },
                    onSaveFail(r) {
                        if (r.errors && r.errors.fieldErrors && r.errors.fieldErrors.length > 0) {
                            let self = this, errors = r.errors.fieldErrors, title = null, code = null;
                            for (let e of errors) {
                                if (e.name == 'title' && e.code == 'exists') {
                                    title = self.getFieldValue('title');
                                } else if (e.name == 'code' && e.code == 'exists') {
                                    code = self.getFieldValue('code');
                                }
                            }
                            if (title || code) {
                                self.$dialog.crud('重复题目筛选', {
                                    url: '/home/admin/c/question', params: { _thash: title != null, _questionType: self.params._type, title: title, code: code }, createable: false,
                                    searchable: false, searching: true,
                                    desc: '<p class="sys-alert">下面列出的是可能重复的题目，请根据实际情况进行处理。如果不需要处理，可以直接点击下方<b>不理重复</b>按钮，继续创建题目。</p>'
                                }, [{
                                    label: '不理重复', func() {
                                        self.$dialog.close();
                                        self.save({ _force: true });
                                    }
                                }]);
                            }
                        }
                    }
                };
                if (self.$store.state.account.tenantId == 0) {
                    cfgs.listActions.push(
                        {
                            label: '开放', whereSel: true, func() {
                                let self = this, sel = self.selected();
                                if (sel) {
                                    let keys = Object.keys(sel);
                                    if (keys.length > 0) {
                                        self.$axios.get(`/home/admin/c/question/update/pri/ids/false/${keys.join('_')}`).then(() => {
                                            self.refresh(false, true);
                                        });
                                    }
                                }
                            }
                        }, {
                        label: '不开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/question/update/pri/ids/true/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    });
                    if (i) {
                        cfgs.listActions.push({
                            label: '按目录开放', confirm: '确认要把当前选中目录批量标记为开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/question/update/pri/batch/${i.domainId}/${i.id || 0}/false`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '按目录不开放', confirm: '确认要把当前选中目录批量标记为不开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/question/update/pri/batch/${i.domainId}/${i.id || 0}/true`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        });
                    }
                }
                return cfgs;
            }
        },
        children: [
            {
                path: 'sub/:_pid', component: CrudRouter, meta: {
                    name: '小题管理',
                    url: 'home/admin/c/question',
                    createable: false, refreshable: false,
                    listActions: [
                        { label: '加判断', func() { this.$parent.onEdit(null, { _type: 2 }); } },
                        { label: '加单选', func() { this.$parent.onEdit(null, { _type: 1 }); } },
                        { label: '加多选', func() { this.$parent.onEdit(null, { _type: 3 }); } }
                    ],
                    listItemActions: [
                        {
                            label: '题目预览', icon: 'visibility', func(cfg) {
                                let self = this;
                                self.$dialog.component('题目预览', "question-view", {
                                    targetId: cfg.item.id,
                                });
                            }
                        }
                    ]
                }
            }
        ]
    },
    {
        path: 'home/admin/c/paper', component: TreeCrudRouter, meta: {
            tree: { disableActiveFirst: true, ...catalogTree() },
            acceptEmptyActive: true,
            crud(i) {
                let self = this;
                let cfgs = {
                    genParams(i) {
                        return i ? { _cata: i.domainId ? i.id : 0, _domain: i.domainId || i.id } : {};
                    },
                    desc: i ? null : '<p class="sys-info">选择左边<b>资源分类目录</b>开始<b>新建试卷</b></p>',
                    createable: i != null,
                    listItemActions: [{
                        label: '收藏', icon: 'favorite_border', func(cfg) {
                            this.$favorite(4, cfg.item.id);
                        }
                    }, {
                        label: '大题管理', icon: 'dehaze', func(cfg) {
                            this.$router.push(`/console/home/admin/c/paper/group/${cfg.item.id}`, `大题管理 - ${cfg.item.name}`);
                        }
                    }, {
                        label: '预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component(`试卷预览 - ${cfg.item.name}`, "paper-view", {
                                id: cfg.item.id,
                                exportUrl: self.$store.state.account.exportPaper ? `${self.$const.baseUrl}/home/admin/c/paper/export/docx/${cfg.item.id}` : ''
                            });
                        }
                    }, {
                        label: '引用培训方案', order: -1, icon: 'call_split', func(cfg) {
                            this.$dialog.component(`引用该试卷的培训方案 - ${cfg.item.name}`, PaperRefers, { paperId: cfg.item.id });
                        }
                    }, {
                        label: '导入试卷及题目', icon: 'cloud_upload', func(cfg) {
                            let self = this;
                            self.$dialog.component(`导入 - ${cfg.item.name}`, SimpleUploader, {
                                width: 600,
                                persist: true,
                                url: `/home/admin/c/paper/import/${cfg.item.id}`,
                                templateUrl: '/s/a/paper_import.xlsx',
                                contentType: 'application/zip,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                onUploadComplete(r) {
                                    if (r.data && r.data.status == 'ok') {
                                        let hash = r.data.hash || {}, oGroups = r.data.groups || [];
                                        //如果没有重复的题目且原来试卷没题目，直接导入
                                        if (Object.keys(hash).length == 0 && oGroups.length == 0) {
                                            self.$dialog.close();
                                            self.$axios.post(`/home/admin/c/paper/do_import/${cfg.item.id}`).then(() => {
                                                self.$status('导入成功！', 'success');
                                                self.refresh();
                                            });
                                            return;
                                        }
                                        //如果有重复题目或原试卷有题目，弹出导入调整和确认部分。
                                        self.$dialog.component('导入题目确认', PaperImportParse, {
                                            ...r.data, paperId: cfg.item.id, fullscreen: true, onSuccess() {
                                                self.refresh();
                                            }
                                        });
                                    } else {
                                        let err = r.data ? r.data.message : '导入出现错误';
                                        if (typeof err == 'string') {
                                            self.$status(err, 'error');
                                        } else {
                                            //弹出一个对话框，列出导入的错误列表
                                            self.$dialog.component('导入错误信息', DataList, {
                                                width: 600,
                                                heads: [{ label: '行', name: 'row' }, { label: '列', name: 'col' }, { label: '说明', name: 'message' }],
                                                data: r.data.message
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    }, {
                        label: '禁用', icon: 'visibility_off', func(cfg) {
                            let self = this, status = self.$dictVal(cfg.item.status);
                            self.$axios.get(`/home/admin/c/paper/status/${cfg.item.id}/${!status ? 1 : 0}`).then(r => {
                                if (r.data) {
                                    if (r.data.status == "ok") {
                                        self.$status('操作成功', 'success');
                                        self.refresh();
                                    } else {
                                        self.$status(r.data.message || "操作失败！", 'error');
                                    }
                                }
                            });
                        }
                    }, {
                        label: '复制试卷', icon: 'file_copy', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/c/paper/copy/${cfg.item.id}`).then(r => {
                                if (r.data) {
                                    if (r.data.status == "ok") {
                                        self.$status('复制成功', 'success');
                                        self.refresh();
                                    } else {
                                        self.$status(r.data.message || "复制失败！", 'error');
                                    }
                                }
                            });
                        }
                    }, {
                        label: '导出题目',
                        icon: 'save_alt',
                        func(cfg) {
                            window.open(`${this.$const.baseUrl}/home/admin/c/paper/export/questions/${cfg.item.id}`, '_blank');
                        }
                    }],
                    listItemFilter(i, acts) {
                        let status = this.$dictVal(i.status);
                        if (!status || status != 1) {
                            let act = acts.find(a => a.icon == "visibility_off");
                            act.icon = "done";
                            act.label = "激活";
                        }

                        if (i.questionCount > 0) {
                            acts.find(a => a.icon == 'cloud_upload').label = '导入更新题目';
                        }

                        if (!this.$isInRole('ROLE_SUPER')) {
                            this.delAction(acts, 'icon', 'save_alt');
                        }
                        return acts;
                    }
                };

                if (self.$isInRole('ROLE_SUPER')) {
                    cfgs.listItemActions.push({
                        label: '语言设置', icon: 'language', func(cfg) {
                            self.$dialog.component(`语言设置 - ${cfg.item.name}`, LangSettings, {
                                width: 800, fields: [
                                    { category: 5, type: 1, categoryId: cfg.item.id, targetId: 0, label: '名称' },
                                    { category: 5, type: 2, categoryId: cfg.item.id, targetId: 0, label: '描述', textarea: true }
                                ]
                            });
                        }
                    });
                }

                cfgs.selectStyle = 'multi';
                let acts = [{
                    label: '移动', whereSel: true, func() {
                        let self = this, sel = self.selected();
                        if (!sel) {
                            return;
                        }
                        let keys = Object.keys(sel);
                        if (keys.length <= 0) {
                            return;
                        }

                        self.$dialog.component('选择目标目录', Tree, { width: 300, ...catalogTree() }, [
                            {
                                label: '确认移动', func(sel) {
                                    if (!sel || !sel.actived) { return }
                                    sel = sel.actived;
                                    self.$axios.get(`/home/admin/c/paper/catalog/move/${sel.domainId || sel.id}/${sel.domainId ? sel.id : 0}/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                        self.$status('移动成功～', 'success');
                                    });
                                }
                            }
                        ]);
                    }
                }];
                if (self.$store.state.account.tenantId == 0) {
                    acts.push(
                        {
                            label: '开放', whereSel: true, func() {
                                let self = this, sel = self.selected();
                                if (sel) {
                                    let keys = Object.keys(sel);
                                    if (keys.length > 0) {
                                        self.$axios.get(`/home/admin/c/paper/update/pri/ids/false/${keys.join('_')}`).then(() => {
                                            self.refresh(false, true);
                                        });
                                    }
                                }
                            }
                        }, {
                        label: '不开放', whereSel: true, func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                let keys = Object.keys(sel);
                                if (keys.length > 0) {
                                    self.$axios.get(`/home/admin/c/paper/update/pri/ids/true/${keys.join('_')}`).then(() => {
                                        self.refresh(false, true);
                                    });
                                }
                            }
                        }
                    });
                    if (i) {
                        acts.push({
                            label: '按目录开放', confirm: '确认要把当前选中目录批量标记为开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/paper/update/pri/batch/${i.domainId}/${i.id || 0}/false`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '按目录不开放', confirm: '确认要把当前选中目录批量标记为不开放？', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/c/paper/update/pri/batch/${i.domainId}/${i.id || 0}/true`).then(() => {
                                    self.$status('批量更改成功!', 'success');
                                    self.refresh();
                                });
                            }
                        });
                    }
                }
                cfgs.listActions = acts;
                return cfgs;
            }
        },
        children: [
            {
                path: 'group/:_paperid', component: CrudRouter, meta: {
                    titleField: 'title',
                    name: '大题管理', listItemActions: [{
                        label: '题目管理',
                        icon: 'list',
                        func(cfg) {
                            let self = this;
                            self.$dialog.crud(`题目管理 - ${cfg.item.title}`, { url: '/home/admin/c/paper/group/item', params: { _groupId: cfg.item.id } });
                        }
                    }, {
                        label: '从收藏夹添加题目',
                        icon: 'playlist_add',
                        func(cfg) {
                            let self = this;
                            self.$dialog.crud(`选择题目 - ${cfg.item.title}`, { url: '/home/my/favorite', params: { _type: 3 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    sel = Object.values(sel);
                                    if (sel.length == 0) {
                                        return;
                                    }
                                    let qIds = [];
                                    for (let k in sel) {
                                        qIds.push(sel[k].targetId);
                                    }
                                    self.$axios.get(`/home/admin/c/paper/group/item/add/question`, { params: { _groupId: cfg.item.id, questions: qIds.join(',') } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('添加成功', 'success');
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "添加失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    },
                    {
                        label: '从题库检索添加题目',
                        icon: 'add',
                        func(cfg) {
                            let self = this;
                            self.$dialog.crud(`选择题目 - ${cfg.item.title}`, { url: '/home/admin/c/question', params: { _questionType: self.$dictVal(cfg.item.questionType) }, editable: false, deleteable: false, createable: false, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    sel = Object.keys(sel);
                                    if (sel.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/c/paper/group/item/add/question`, { params: { _groupId: cfg.item.id, questions: sel.join(',') } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('添加成功', 'success');
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "添加失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    },
                    {
                        label: '规则管理',
                        icon: 'apps',
                        func(cfg) {
                            let self = this;
                            self.$dialog.crud(`规则管理 - ${cfg.item.title}`, { url: '/home/admin/c/paper/group/rule', params: { _groupId: cfg.item.id } });
                        }
                    }, {
                        label: '语言设置', icon: 'language', func(cfg) {
                            let self = this;
                            self.$dialog.component(`语言设置 - ${cfg.item.title}`, LangSettings, {
                                width: 800, fields: [
                                    { category: 5, type: 3, categoryId: self.$route.params._paperid, targetId: cfg.item.id, label: '标题' }
                                ]
                            });
                        }
                    }]
                }
            }
        ]
    },
    {
        path: 'home/admin/c/article', component: AdminArticle,
        children: [
            {
                path: 'log/:_articleId', component: AutoRouter, meta() {
                    let self = this, a = self.$store.state.account, crud = {
                        name: '阅读记录',
                        url: '/home/admin/c/article/log',
                        desc: '<p class="sys-info">阅读记录只列出左边选择机构自身人员的记录，不会列出其下属机构人员的。</p>',
                        listActions: [{
                            label: '导出', func() {
                                let cSelf = this, url = `${self.$const.baseUrl}/home/admin/c/article/log/export.xlsx?_articleId=${self.$route.params._articleId}`;
                                if (cSelf.cfg.params && cSelf.cfg.params._oid) {
                                    url += `&_oid=${cSelf.cfg.params._oid}`;
                                }
                                window.open(url);
                            }
                        }]
                    };
                    if (a.orgType == 1) {
                        return crud;
                    } else {
                        return { name: '阅读记录', tree: orgTree(), crud: { genParams(i) { let p = {}; if (i) { p._oid = i.id; } return p; }, ...crud } };
                    }
                }
            },
            {
                path: 'comment/:_articleId', component: CrudRouter, meta: {
                    url: '/home/admin/c/article/comment',
                    createable: false, editable: false, detailable: false,
                    name: '评论管理',
                    listItemActions: [{
                        label: '审核不通过', icon: 'visibility_off', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/c/article/comment/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) === 0 ? 1 : 0}`).then(() => {
                                self.refresh();
                            });
                        }
                    }, {
                        label: '取消置顶', icon: 'vertical_align_bottom', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/c/article/comment/top/${cfg.item.id}/${cfg.item.topTimestamp === 0 ? true : false}`).then(() => {
                                self.refresh();
                            });
                        }
                    }, {
                        label: '回复管理', icon: 'reply', func(cfg) {
                            let self = this;
                            self.$dialog.crud('回复管理', {
                                url: '/home/admin/c/article/comment', detailable: false, editable: false, params: { _replyId: cfg.item.id, _articleId: self.$route.params._articleId }, listItemActions: [{
                                    label: '审核不通过', icon: 'visibility_off', func(cfg) {
                                        let self = this;
                                        self.$axios.get(`/home/admin/c/article/comment/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) === 0 ? 1 : 0}`).then(() => {
                                            self.refresh();
                                        });
                                    }
                                }, {
                                    label: '取消置顶', icon: 'vertical_align_bottom', func(cfg) {
                                        let self = this;
                                        self.$axios.get(`/home/admin/c/article/comment/top/${cfg.item.id}/${cfg.item.topTimestamp === 0 ? true : false}`).then(() => {
                                            self.refresh();
                                        });
                                    }
                                }],
                                listItemFilter(i, acts) {
                                    if (this.$dictVal(i.status) === 0) {
                                        let act = acts.find(a => a.icon == "visibility_off");
                                        act.icon = "done";
                                        act.label = "审核通过";
                                    }
                                    if (i.topTimestamp === 0) {
                                        let act = acts.find(a => a.icon == "vertical_align_bottom");
                                        act.icon = "vertical_align_top";
                                        act.label = "置顶";
                                    }
                                    return acts;
                                }
                            });
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (this.$dictVal(i.status) === 0) {
                            let act = acts.find(a => a.icon == "visibility_off");
                            act.icon = "done";
                            act.label = "审核通过";
                        }
                        if (i.topTimestamp === 0) {
                            let act = acts.find(a => a.icon == "vertical_align_bottom");
                            act.icon = "vertical_align_top";
                            act.label = "置顶";
                        }
                        return acts;
                    }
                }
            },
        ]
    },
    {
        path: 'home/admin/c/crule', component: CrudRouter, meta: {
            listItemActions: [
                {
                    label: '课件设置', icon: 'playlist_play', func(cfg) {
                        this.$router.push(`/console/home/admin/c/crule/courseware/${cfg.item.id}`);
                    }
                },
                {
                    label: '考试设置', icon: 'book', func(cfg) {
                        this.$router.push(`/console/home/admin/c/crule/paper/${cfg.item.id}`);
                    }
                }, {
                    label: '预览', icon: 'visibility', func(cfg) {
                        this.$dialog.component(cfg.item.name + '预览', "clazzrule-view", { targetId: cfg.item.id, fullscreen: true });
                    }
                },
                {
                    label: '使用的培训计划', order: -1, icon: 'call_split', func(cfg) {
                        this.$dialog.crud('使用的培训计划', {
                            url: '/home/admin/c/crule/ref', params: { _ruleId: cfg.item.id },
                            listActions: [{
                                label: '导出', func() {
                                    let self = this;
                                    window.open(`${self.$const.baseUrl}/home/admin/c/crule/ref/export.xlsx?_ruleId=${cfg.item.id}`, '_blank');
                                }
                            }]
                        });
                    }
                },
                {
                    label: '收藏', icon: 'favorite_border', func(cfg) {
                        this.$favorite(6, cfg.item.id);
                    }
                }, {
                    label: '取消发布', icon: 'visibility_off', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/c/crule/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) == 0 ? 1 : 0}`).then(r => {
                            if (r.data) {
                                if (r.data.status == "ok") {
                                    self.$status('操作成功', 'success');
                                    self.refresh();
                                } else {
                                    self.$status(r.data.message || "操作失败！", 'error');
                                }
                            }
                        });
                    }
                }, {
                    label: '语言设置', order: -8, icon: 'language', func(cfg) {
                        this.$dialog.component(`语言设置 - ${cfg.item.name}`, LangSettings, {
                            width: 800,
                            fields: [{ category: 2, type: 3, categoryId: cfg.item.id, targetId: 0, label: '名称' },
                            { category: 2, type: 2, categoryId: cfg.item.id, targetId: 0, label: '介绍', textarea: true }]
                        });
                    }
                }],
            listItemFilter(i, acts) {
                let self = this;
                if (self.$dictVal(i.status) == 0) {
                    let act = acts.find(a => a.icon == "visibility_off");
                    act.icon = "done";
                    act.label = "发布";
                }
                if (i.clazzCount && i.clazzCount > 0 && !self.$isSuperman()) {
                    this.delAction(acts, "icon", "book");
                    this.delAction(acts, "icon", "playlist_play");
                    this.delAction(acts, "__tag", "delete");
                    this.delAction(acts, "__tag", "edit");
                }
                if (!self.$isInRole('ROLE_SUPER')) {
                    this.delAction(acts, 'icon', 'language');
                }
                return acts;
            }
        },
        children: [
            {
                path: 'paper/:_ruleId', component: CrudRouter, meta: {
                    name: '考试设置', pagable: false, createable: false,
                    listItemActions: [{
                        label: '预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component('试卷预览', "paper-view", {
                                id: cfg.item.paperId
                            });
                        }
                    }, {
                        label: '语言设置', icon: 'language', func(cfg) {
                            this.$dialog.component(`语言设置 - ${cfg.item.paperName}`, LangSettings, {
                                width: 800,
                                fields: [{ category: 2, type: 4, categoryId: this.$route.params._ruleId, targetId: cfg.item.id, label: '名称' }]
                            });
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (!this.$isInRole('ROLE_SUPER')) {
                            this.delAction(acts, 'icon', 'language');
                        }
                        return acts;
                    },
                    listActions: [{
                        label: '添加考试', func() {
                            let self = this;
                            self.$dialog.crud('从收藏中选择试卷', { url: '/home/my/favorite', params: { _type: 4 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = [];
                                    for (let v in sel) {
                                        let o = sel[v];
                                        ids.push(o.targetId);
                                    }
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/c/crule/paper/add/paper/${ids.join('_')}`, { params: { _ruleId: self.cfg.params._ruleId, _type: 1 } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }, {
                        label: '添加练习', func() {
                            let self = this;
                            self.$dialog.crud('从收藏中选择试卷', { url: '/home/my/favorite', params: { _type: 4 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = [];
                                    for (let v in sel) {
                                        let o = sel[v];
                                        ids.push(o.targetId);
                                    }
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/c/crule/paper/add/paper/${ids.join('_')}`, { params: { _ruleId: self.cfg.params._ruleId, _type: 2 } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }]
                }
            },
            {
                path: 'courseware/:_ruleId', component: CrudRouter, meta: {
                    name: '课件设置', pagable: false, createable: false,
                    listItemActions: [{
                        label: '预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component(cfg.item.coursewareName, "courseware-view", {
                                targetId: cfg.item.coursewareId,
                                fullscreen: true
                            });
                        }
                    }, {
                        label: '语言设置', icon: 'language', func(cfg) {
                            this.$dialog.component(`语言设置 - ${cfg.item.coursewareName}`, LangSettings, {
                                width: 800,
                                fields: [{ category: 2, type: 1, categoryId: this.$route.params._ruleId, targetId: cfg.item.id, label: '名称' }]
                            });
                        }
                    }],
                    listActions: [{
                        label: '添加必学', func() {
                            let self = this;
                            self.$dialog.crud('从收藏中选择必学课件', { url: '/home/my/favorite', params: { _type: 2 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = [];
                                    for (let v in sel) {
                                        let o = sel[v];
                                        ids.push(o.targetId);
                                    }
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/c/crule/courseware/add/cw/${ids.join('_')}`, { params: { _ruleId: self.cfg.params._ruleId } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }, {
                        label: '添加选学', func() {
                            let self = this;
                            self.$dialog.crud('从收藏中选择选学课件', { url: '/home/my/favorite', params: { _type: 2 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = [];
                                    for (let v in sel) {
                                        let o = sel[v];
                                        ids.push(o.targetId);
                                    }
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/c/crule/courseware/add/cw/${ids.join('_')}`, { params: { _ruleId: self.cfg.params._ruleId, _opt: true } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (!this.$isInRole('ROLE_SUPER')) {
                            this.delAction(acts, 'icon', 'language');
                        }
                        return acts;
                    }
                }
            }
        ]
    },
    {
        path: 'home/my/a', component: CrudRouter, meta: {
            editable: true, initPanel: 'detail', targetId: 0,
            actions: [{
                label: '修改密码', func() {
                    this.onEdit(1, { _chgpwd: true });
                }
            }, {
                label: '修改信息', func() {
                    this.onEdit(1);
                }
            }]
        }
    },
    {
        path: 'home/my/favorite', component: CrudRouter, meta: {
            selectStyle: 'multi',
            listItemActions: [{
                label: '预览', icon: 'visibility', func(cfg) {
                    let self = this, type = self.$dictVal(cfg.item.type);
                    if (type == 1) {
                        self.$axios.get(`/home/my/media/cc/url/${cfg.item.targetId}`).then(r => {
                            if (r.data && r.data.status == 'ok' && r.data.message) {
                                self.$dialog.component(cfg.item.name, 'cc-video-viewer', { movieUrl: r.data.message });
                            }
                        });
                    } else {
                        let component = null, fullscreen = false;
                        switch (type) {
                            case 2:
                                component = "courseware-view";
                                break;
                            case 3:
                                component = "question-view";
                                break;
                            case 4:
                                component = "paper-view";
                                break;
                            case 5:
                                component = "article-view";
                                break;
                            case 6:
                                component = "clazzrule-view";
                                fullscreen = true;
                                break;
                        }
                        component && self.$dialog.component(cfg.item.name, component, {
                            fullscreen: fullscreen,
                            targetId: cfg.item.targetId, id: cfg.item.targetId
                        });
                    }
                }
            }]
        }
    },
    { path: 'home/my/media', component: MediaRepo, meta: { name: '视频库' } },
    { path: 'home/my/courseware', component: CoursewareRepo, meta: { name: '课件库' } },
    { path: 'home/my/question', component: QuestionRepo, meta: { name: '题目库' } },
    { path: 'home/my/paper', component: PaperRepo, meta: { name: '试卷库' } },
    { path: 'home/my/article', component: ArticleRepo, meta: { name: '阅读库' } },
    { path: 'home/my/crule', component: ClazzruleRepo, meta: { name: '培训方案' } }
];
export default {
    routers: routers
}